import { Link } from "react-router-dom";
import { Wrench, HardHat, Paintbrush, ClipboardList, ExternalLink } from "lucide-react";

const SERVICES = [
  {
    icon: HardHat,
    title: "İnşaat & Yapı",
    description: "Villa, konut, ticari yapı ve rezidans projeleri.",
    slug: "insaat",
  },
  {
    icon: Wrench,
    title: "Renovasyon & Tadilat",
    description: "Mevcut yapıların yenilenmesi ve modernizasyonu.",
    slug: "renovasyon",
  },
  {
    icon: Paintbrush,
    title: "İç Mimari",
    description: "Kişiye özel iç mekan tasarımı ve uygulaması.",
    slug: "ic-mimari",
  },
  {
    icon: ClipboardList,
    title: "Proje Yönetimi",
    description: "Başlangıçtan teslimata uzanan süreç yönetimi.",
    slug: "proje-yonetimi",
  },
];

const AdminServices = () => (
  <div>
    <div className="flex items-center justify-between mb-8">
      <div>
        <p className="text-[#C5A059] text-[10px] tracking-[0.25em] uppercase mb-1">İçerik</p>
        <h1 className="text-[#F5F5F7] text-2xl font-light">Hizmetler</h1>
      </div>
      <a
        href="/hizmetler"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 text-xs text-[#555] hover:text-[#C5A059] transition-colors"
      >
        <ExternalLink size={12} />
        Siteyi Görüntüle
      </a>
    </div>

    {/* Info banner */}
    <div className="bg-[#C5A059]/5 border border-[#C5A059]/15 px-4 py-3 mb-6 flex items-start gap-3">
      <Wrench size={14} className="text-[#C5A059] flex-shrink-0 mt-0.5" />
      <div>
        <p className="text-[#C5A059] text-xs font-medium mb-0.5">Statik İçerik</p>
        <p className="text-[#86868B] text-xs font-light leading-relaxed">
          Hizmetler şu an kod içinde tanımlıdır (<code className="text-[#C5A059]/80">ServicesPage.js</code>).
          Dinamik CMS yönetimine geçmek için bir <code className="text-[#C5A059]/80">services</code> tablosu
          oluşturulabilir. Mevcut hizmetler aşağıda listelenmiştir.
        </p>
      </div>
    </div>

    <div className="bg-[#0a0a0a] border border-white/5 overflow-hidden divide-y divide-white/4">
      {SERVICES.map((svc, i) => {
        const Icon = svc.icon;
        return (
          <div key={i} className="flex items-center gap-4 px-5 py-4 hover:bg-white/2 transition-colors">
            <div className="w-8 h-8 bg-[#C5A059]/8 flex items-center justify-center flex-shrink-0">
              <Icon size={14} className="text-[#C5A059]" strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <p className="text-[#F5F5F7] text-sm font-light">{svc.title}</p>
              <p className="text-[#555] text-xs mt-0.5">{svc.description}</p>
            </div>
            <span className="text-[10px] text-[#333] font-mono">#{i + 1}</span>
          </div>
        );
      })}
    </div>

    <div className="mt-6 pt-5 border-t border-white/5">
      <p className="text-[#444] text-xs mb-3">Hizmet içeriğini güncellemek için:</p>
      <Link
        to="/admin/projeler"
        className="inline-flex items-center gap-2 text-xs text-[#C5A059] hover:underline"
      >
        ← Projeleri Yönet
      </Link>
    </div>
  </div>
);

export default AdminServices;
